import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPprServiceApplicationAvailableColumns } from './api';

export const path = '/ppr/application/list';

const PageApplicationListPpr: React.FC = (props) => {
  const ApplicationListPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPprServiceApplicationAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <ApplicationListPpr {...props} />;
};

export default PageApplicationListPpr;
